<template>
  <div class="lista">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title v-for="(value, name, index) in dados" :key="index">
          <span class="font-weight-black">{{name}}:</span>
          {{value}}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>
<script>
export default {
  name: "ListaComponent",
  props: {
    dados: {
      type: Object
    }
  }
};
</script>